import { useState } from 'react';
import { BACKEND_ENABLED } from '../../config';

export default function AddItemBar({ onAdd, onOpenReceipt, onOpenPhoto }) {
  const [text, setText] = useState('');

  function submit(e) {
    e.preventDefault();
    const name = text.trim();
    if (!name) return;
    onAdd([{
      id:         crypto.randomUUID(),
      name,
      quantity:   1,
      unit:       '',
      is_checked: false,
      added_via:  'manual',
    }]);
    setText('');
  }

  return (
    <form className="aib-wrap" onSubmit={submit}>
      <input
        className="aib-input"
        type="text"
        placeholder="Add an item…"
        value={text}
        onChange={e => setText(e.target.value)}
      />
      <button
        type="submit"
        className="aib-btn aib-btn--add"
        disabled={!text.trim()}
        aria-label="Add item"
      >
        +
      </button>
      {BACKEND_ENABLED && (
        <button
          type="button"
          className="aib-btn aib-btn--photo"
          onClick={onOpenPhoto}
          aria-label="Identify product by photo"
          title="Identify by photo"
        >
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
            <circle cx="12" cy="13" r="4"/>
          </svg>
        </button>
      )}
      {BACKEND_ENABLED && (
        <button
          type="button"
          className="aib-btn aib-btn--receipt"
          onClick={onOpenReceipt}
          aria-label="Scan receipt"
          title="Scan receipt"
        >
          🧾
        </button>
      )}
    </form>
  );
}
